import React from 'react';

function QuestionCardCheckboxIcon() {
    return (
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.8334" y="1" width="12" height="12" rx="1" fill="white" />
            <rect x="1.8334" y="1" width="12" height="12" rx="1" stroke="#7D7D82" stroke-width="2" />
        </svg>
    );
}

export default QuestionCardCheckboxIcon;
